import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { Maybe } from '@/lib/types';

import { visibilityControl } from '../../Card.styles';
export const MediaWrapper = styled(Box)<{
  $aspectRatio?: { x: number; y: number };
  $mediaAnimationEffect: Maybe<string>;
}>`
  width: 100%;
  position: relative;

  ${({ $aspectRatio }) =>
    $aspectRatio &&
    css`
      aspect-ratio: ${$aspectRatio.x} / ${$aspectRatio.y};
    `};
  ${({ $mediaAnimationEffect }) => css`
    ${$mediaAnimationEffect &&
    css`
      &:hover {
        cursor: pointer;
        img {
          transform: scale(1.1);
          transition: all 0.5s linear;
        }
      }
    `}
  `};
`;

export const Container = styled(Box)<{
  $backgroundColor: string;
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;

export const Media = styled(Box)<{
  $backgroundAlignment: Maybe<string>;
}>`
  inset: 0;
  object-fit: cover;
  background-position: center;
  position: absolute;

  ${({ $backgroundAlignment, theme }) => css`
    ${theme.media.md.down} {
      object-position: ${$backgroundAlignment || 'center'};
    }
  `}
`;
